import { creditAccount } from 'src/app/queries/queries'

const creditAccountTransactions = (page, success, error) => {
  return {
    type: 'API:CREDIT_ACCOUNT_TRANSACTIONS',
    API: true,
    method: 'POST',
    url: '/api/query',
    success,
    error,
    data: {
      query: creditAccount.QUERY_CREDIT_ACCOUNT_TRANSACTIONS,
      variables: { page, per_page: 20 }
    }
  }
}

const creditAccountBanlance = () => {
  return {
    type: 'API:CREDIT_ACCOUNT_BANLANCE',
    API: true,
    method: 'POST',
    url: '/api/query',
    data: {
      query: creditAccount.QUERY_CUSTOMER_BALANCE
    }
  }
}

const paymentOverdraft = (input, success, error) => {
  return {
    type: 'API:PAYMENT:OVERDRAFT',
    API: true,
    method: 'POST',
    url: '/api/query',
    success,
    error,
    data: {
      query: creditAccount.MUTATION_PURCHASE_OVERDRAFT,
      variables: { input }
    }
  }
}
export default {
  creditAccountBanlance,
  creditAccountTransactions,
  paymentOverdraft
}
